import { Component } from '@angular/core';

/**
 * Placeholder host for the root route. The {@link rootRedirectGuard} always
 * returns a UrlTree, so this component is never actually rendered — it only
 * exists to give the matched '' route something to activate.
 */
@Component({
  selector: 'app-root-redirect',
  standalone: true,
  template: '',
})
export class RootRedirectComponent {}
